import { render, staticRenderFns } from "./house-add.vue?vue&type=template&id=6a180836&scoped=true&"
import script from "./house-add.vue?vue&type=script&lang=js&"
export * from "./house-add.vue?vue&type=script&lang=js&"
import style0 from "./house-add.vue?vue&type=style&index=0&id=6a180836&scoped=true&lang=css&"
import style1 from "./house-add.vue?vue&type=style&index=1&id=6a180836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a180836",
  null
  
)

export default component.exports